/**
 * Schutz vor ungewolltem Arbeitsverlust.
 *
 * Eine Ansicht mit ungesicherten Änderungen meldet sich hier an; der Router
 * fragt vor jedem Wechsel nach. Ohne das genügte ein Klick auf „Empfänger"
 * mitten im Bauen einer Vorlage, um alles seit dem letzten Speichern zu
 * verlieren — ohne Rückfrage, ohne Hinweis, und bemerkt wird es erst beim
 * Zurückkommen.
 *
 * Eigenes Modul, weil sowohl der Router als auch die Ansichten darauf
 * zugreifen: läge es in app.js, würden sich beide gegenseitig importieren.
 */

/** @type {null | (() => string|null)} */
let waechter = null;

/**
 * Meldet ungesicherte Arbeit an. Die Prüfung liefert den Grund im Klartext
 * oder null, wenn nichts offen ist.
 *
 * @param {() => string|null} pruefung
 */
export function verlassenSchuetzen(pruefung) {
  waechter = pruefung;
}

/** Hebt den Schutz auf — nach dem Speichern oder beim Verlassen der Ansicht. */
export function verlassenFreigeben() {
  waechter = null;
}

/**
 * Grund, der einem Wechsel entgegensteht — oder null.
 * @returns {string|null}
 */
export function verlassenGrund() {
  return waechter ? waechter() : null;
}
